// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "net.shinobi-wallet",
    name: "Shinobi-Wallet",
    homepage: "https://shinobi-wallet.net/",
    image_id: "685c986c-3e80-4701-cec6-cd247ba1a700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/fgraph/id1572609905",
        android: "https://play.google.com/store/apps/details?id=io.fgraph.shinobiwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "shinobi-wallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map